import { makeStyles, useTheme } from '@material-ui/core/styles';
import ChevronLeftIcon from '@material-ui/icons/ChevronLeft';
import ChevronRightIcon from '@material-ui/icons/ChevronRight';
import MenuIcon from '@material-ui/icons/Menu';
import clsx from 'clsx';
import React from 'react';
import LanguageButton from '../components/languageButton';
import LogoutButton from '../components/logoutButton';
import { GNB_WEBSITE_EN, GNB_WEBSITE_FR } from '../globals/settings';
import logoFr from '../images/MaSanteNB-Logo.png';
import logo from '../images/MyHealthNB-Logo.png';
import { DISABLE_HEADER_FOOTER } from "../globals/settings"
import { LANG_EN } from '../util/language';

import { 
    AppBar, CssBaseline, Divider, 
    Drawer, IconButton, List, 
    Toolbar, Typography
} from '@material-ui/core';

export default function PersistentDrawerRight(props) {
    const classes = useStyles();
    const theme = useTheme();
    const [open, setOpen] = React.useState(false);

    const handleDrawerOpen = () => {
        setOpen(true);
    };

    const handleDrawerClose = () => {
        setOpen(false);
    };

    const getLink = (lang) => {
        if (lang === LANG_EN) {
            return GNB_WEBSITE_EN;
        } else {
            return GNB_WEBSITE_FR;
        }
    }

    const getImage = (lang) => {
        if (lang === LANG_EN) {
            return logo;
        } else {
            return logoFr;
        }
    }

    if(DISABLE_HEADER_FOOTER){
        return null;
    }

    return (
        <div>
            <div className="navbar-space-fix"/>
            <div className={classes.root}>
                <CssBaseline />
                <AppBar position="fixed">
                    <Toolbar>
                        <Typography variant="h6" noWrap className={classes.title}>
                            <a href={getLink(props.language)}><img src={getImage(props.language)} alt="MyHealthNB" width="125"/></a>
                        </Typography>
                        <IconButton
                            color="inherit"
                            aria-label="open drawer"
                            edge="end"
                            onClick={handleDrawerOpen}
                            className={clsx(open && classes.hide)}>
                            <MenuIcon />
                        </IconButton>
                    </Toolbar>
                </AppBar>
                <Drawer
                    className={classes.drawer}
                    variant="persistent"
                    anchor="right"
                    open={open}
                    classes={{ paper: classes.drawerPaper }}
                >
                    <div className={classes.drawerHeader}>
                        <IconButton onClick={handleDrawerClose}>
                            {theme.direction === 'rtl' ? <ChevronLeftIcon /> : <ChevronRightIcon />}
                        </IconButton>
                    </div>
                    <Divider />
                    <List>
                        <LanguageButton />
                        <LogoutButton />
                    </List>
                </Drawer>
            </div>
        </div>
    );
}

const useStyles = makeStyles(theme => ({
    root: {
    display: 'flex',
    },
    appBar: {
        transition: theme.transitions.create(['margin', 'width'], {
            easing: theme.transitions.easing.sharp,
            duration: theme.transitions.duration.leavingScreen,
        }),
    },
    appBarShift: {
        width: `calc(100% - ${240}px)`,
        transition: theme.transitions.create(['margin', 'width'], {
            easing: theme.transitions.easing.easeOut,
            duration: theme.transitions.duration.enteringScreen,
        }),
        marginRight: 240,
    },
    title: {
        flexGrow: 1,
    },
    hide: {
        display: 'none',
    },
    drawer: {
        width: 240,
        flexShrink: 0,
    },
    drawerPaper: {
        width: 240,
    },
    drawerHeader: {
        display: 'flex',
        alignItems: 'center',
        padding: theme.spacing(0, 1),
        // necessary for content to be below app bar
        ...theme.mixins.toolbar,
        justifyContent: 'flex-start',
    }
}));
